import React, { useEffect, useState } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Helmet } from "react-helmet-async";
import moment from "moment";
import common from "../helper/common";
import { respEnum } from "../constants/appConstant";
import { AppInput, AppSelect } from "../component/appComponents";

const locales = {
  "en-US": require("date-fns/locale/en-US"),
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const Check = () => {
  const [events, setEvents] = useState([]);
  const [resources, setResources] = useState([]);
  const [selectedSport, setSelectedSport] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [sports, setSports] = useState([]);

  // Get today's date at start of day for comparison
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  useEffect(() => {
    GetSports();
  }, []);

  useEffect(() => {
    if (selectedSport !== undefined && selectedSport !== null) {
      fetchCourtWiseBookings();
    }
  }, [selectedSport, selectedDate]);

  const GetSports = async () => {
    try {
      const response = await common.ApiService.getInstance().request(
        "GetClubSports"
      );
      const sportsData = [
        { id: null, name: "Select Sport" },
        ...(response?.data ?? []),
      ];

      setSports(sportsData);

      if (sportsData.length > 1) {
        setSelectedSport(sportsData[1].id);
      }
    } catch (error) {
      console.error("Error fetching sports:", error);
    }
  };

  const fetchCourtWiseBookings = async () => {
    try {
      const formattedDate = moment(selectedDate).format("yyyy-MM-DD");
      const response = await common.ApiService.getInstance().request(
        `GetCourtWiseBookingsByDate?sportId=${selectedSport}&date=${formattedDate}`
      );

      if (response.status === respEnum.Success) {
        const calendarEvents = response.data.flatMap((court) =>
          court.bookings.map((booking) => ({
            id: booking.id,
            title: booking.playerName,
            start: new Date(booking.startDateTime),
            end: new Date(booking.endDateTime),
            resourceId: court.courtId,
          }))
        );

        const calendarResources = response.data.map((court) => ({
          id: court.courtId,
          title: court.courtName,
        }));

        setEvents(calendarEvents);
        setResources(calendarResources);
      }
    } catch (error) {
      console.error("Error fetching court bookings:", error);
    }
  };

  const handleNavigate = (date) => {
    const selectedDay = new Date(date);
    selectedDay.setHours(0, 0, 0, 0);

    // Only update if selected date is today or future
    if (selectedDay >= today) {
      setSelectedDate(date);
    } else {
      setSelectedDate(today); // Reset to today if past date selected
    }
  };

  const handleSportChange = (sportId) => {
    setSelectedSport(sportId);
  };

  const handleDateChange = (date) => {
    const selectedDay = new Date(date);
    selectedDay.setHours(0, 0, 0, 0);

    // Only update if selected date is today or future
    if (selectedDay >= today) {
      setSelectedDate(new Date(date));
    }
  };

  const CustomEvent = ({ event }) => {
    return (
      <div className="p-1">
        <strong>{event.title}</strong>
      </div>
    );
  };

  const isSlotOverlapping = (slotInfo, existingEvents) => {
    return existingEvents.some(
      (event) =>
        event.resourceId === slotInfo.resourceId &&
        slotInfo.start < event.end &&
        slotInfo.end > event.start
    );
  };
  const [timestamp, setTimestamp] = useState(null);
  useEffect(() => {
    setTimestamp(Date.now());
  }, []);
  return (
    <>
      <Helmet>
        <title>Padel Factory Availibility | PlayPro</title>
        <meta name="Padel Factory Availibility" content="HOP" />
      </Helmet>

      <section className="row_am modern_ui_section pt-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="bg-white shadow-md p-3 border-2 border-radius-lg border-gray-300 rounded-lg w-full mb-3">
                <div className="row g-3 align-items-center">
                  <div className="col-md-6">
                    <AppSelect
                      name="sportId"
                      data={sports}
                      value={selectedSport}
                      placeholder="Select Sport"
                      label="Sport"
                      onChange={handleSportChange}
                      className=""
                    />
                  </div>
                  <div className="col-md-6">
                    <AppInput
                      value={moment(selectedDate).format("YYYY-MM-DD")}
                      type="date"
                      label="Date"
                      min={moment(today).format("YYYY-MM-DD")}
                      onChange={(date) => handleDateChange(date)}
                      className=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="bg-white shadow-md p-3 border-2 border-radius-lg border-gray-300 rounded-lg w-full">
                <div style={{ height: "500px" }}>
                  <Calendar
                    localizer={localizer}
                    events={events}
                    resources={resources}
                    resourceIdAccessor="id"
                    resourceTitleAccessor="title"
                    views={["day"]}
                    defaultView="day"
                    selectable
                    date={selectedDate}
                    onNavigate={handleNavigate}
                    min={today} // Set minimum date to today
                    components={{
                      event: CustomEvent,
                    }}
                    style={{ height: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Check;
